<template>
  <v-app>
    <!-- Toolbar -->
    <v-toolbar fixed color="#000000dd" flat>
      <v-toolbar-title class="font-weight-black white--text headline ml-4 pl-2 pr-2 pt-1 pb-1" style="border: 2px solid grey">
        T.K.LIM</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat
          v-for="item in topNavItems"
          :key="item.id" class="theme top-nav"
          :to="{name: `${item.route}`}">
          <span class="font-weight-bold white--text">{{ item.title }}</span>
        </v-btn>
        <v-menu offset-y>
          <v-btn
            slot="activator"
            dark small flat
          >
            Language
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="item in languages"
              :key="item.id"
              @click="changeLocale(item.shortform)">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <!-- Content -->
    <v-content>
      <router-view></router-view>
    </v-content>

    <!-- Footer -->
    <v-footer fixed color="black" dark>
      <v-layout align-center justify-center>
        &copy; 2019 by T.K.Lim Trading.
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      topNavItems: [
        { id: 1, title: 'Home', route: 'home' },
        { id: 2, title: 'About', route: 'about' },
        { id: 3, title: 'Products', route: 'products' },
        { id: 4, title: 'Services', route: 'services' },
        { id: 5, title: 'Contact', route: 'contact' }
      ],
      languages: [
        { id: 1, title: 'English', shortform: 'en' },
        { id: 2, title: 'Chinese', shortform: 'cn' },
        { id: 3, title: 'Malay', shortform: 'bm' }
      ]
    }
  },
  methods: {
    changeLocale (locale) {
      this.$i18n.locale = locale
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/button";
</style>



// WEBPACK FOOTER //
// src/components/layouts/DashboardLayout.vue